import React from 'react';
/**
 * Picture component with AVIF and WebP support
 */
const Picture = ({
  pictureClassname,
  imgClassname,
  onClick,
  xl,
  lg,
  md,
  sm,
  xs,
  alt = '',
  ...rest
}) => {
  return /*#__PURE__*/React.createElement("picture", Object.assign({
    className: pictureClassname ? pictureClassname : '',
    onClick: onClick
  }, rest), (xl === null || xl === void 0 ? void 0 : xl.avif) && /*#__PURE__*/React.createElement("source", {
    srcSet: xl.avif,
    type: "image/avif",
    media: "(min-width: 3840px)"
  }), (xl === null || xl === void 0 ? void 0 : xl.webp) && /*#__PURE__*/React.createElement("source", {
    srcSet: xl.webp,
    type: "image/webp",
    media: "(min-width: 3840px)"
  }), (xl === null || xl === void 0 ? void 0 : xl.srcSet) && /*#__PURE__*/React.createElement("source", {
    srcSet: xl.srcSet,
    media: "(min-width: 3840px)"
  }), " ", (lg === null || lg === void 0 ? void 0 : lg.avif) && /*#__PURE__*/React.createElement("source", {
    srcSet: lg.avif,
    type: "image/avif",
    media: "(min-width: 1441px)"
  }), (lg === null || lg === void 0 ? void 0 : lg.webp) && /*#__PURE__*/React.createElement("source", {
    srcSet: lg.webp,
    type: "image/webp",
    media: "(min-width: 1441px)"
  }), (lg === null || lg === void 0 ? void 0 : lg.srcSet) && /*#__PURE__*/React.createElement("source", {
    srcSet: lg.srcSet,
    media: "(min-width: 1441px)"
  }), " ", (md === null || md === void 0 ? void 0 : md.avif) && /*#__PURE__*/React.createElement("source", {
    srcSet: md.avif,
    type: "image/avif",
    media: "(min-width: 1025px)"
  }), (md === null || md === void 0 ? void 0 : md.webp) && /*#__PURE__*/React.createElement("source", {
    srcSet: md.webp,
    type: "image/webp",
    media: "(min-width: 1025px)"
  }), (md === null || md === void 0 ? void 0 : md.srcSet) && /*#__PURE__*/React.createElement("source", {
    srcSet: md.srcSet,
    media: "(min-width: 1025px)"
  }), " ", (sm === null || sm === void 0 ? void 0 : sm.avif) && /*#__PURE__*/React.createElement("source", {
    srcSet: sm.avif,
    type: "image/avif",
    media: "(min-width: 769px)"
  }), (sm === null || sm === void 0 ? void 0 : sm.webp) && /*#__PURE__*/React.createElement("source", {
    srcSet: sm.webp,
    type: "image/webp",
    media: "(min-width: 769px)"
  }), (sm === null || sm === void 0 ? void 0 : sm.srcSet) && /*#__PURE__*/React.createElement("source", {
    srcSet: sm.srcSet,
    media: "(min-width: 769px)"
  }), " ", (xs === null || xs === void 0 ? void 0 : xs.avif) && /*#__PURE__*/React.createElement("source", {
    srcSet: xs.avif,
    type: "image/avif"
  }), (xs === null || xs === void 0 ? void 0 : xs.webp) && /*#__PURE__*/React.createElement("source", {
    srcSet: xs.webp,
    type: "image/webp"
  }), /*#__PURE__*/React.createElement("img", {
    src: xs.src,
    className: imgClassname || '',
    alt: alt,
    loading: "lazy"
  }));
};
export default Picture;